module.exports = __webpack_public_path__ + "static/chris-1ebaa4a1eb40f240a906f8dd87407296.jpg";